import {
  FETCHED_ALL_MATCHES,
  CLEAR_MATCHES,
  RETURN_MATCHES_ERROR,
} from "../actions/types";
import { decStr } from "../../persistence/crypto/fieldCipher";

const tempAllMatches = sessionStorage.getItem("all_matches");

let _initialMatches = null;
if (tempAllMatches) {
  try {
    // decStr passes through legacy plaintext, so old values still parse.
    _initialMatches = JSON.parse(decStr(tempAllMatches));
  } catch {
    _initialMatches = null;
  }
}

const INITIAL_STATE = {
  all_matches: _initialMatches,
  m_error_msg: null,
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCHED_ALL_MATCHES:
      return { ...state, all_matches: action.payload };
    case CLEAR_MATCHES:
      return { ...state, all_matches: null };
    case RETURN_MATCHES_ERROR:
      return { ...state, m_error_msg: action.payload };
    default:
      return state;
  }
};
